module.exports = __webpack_public_path__ + "static/ISO-45001-84927722a01ac751d05e459d810a1380.png";